/**
 * Extracts the value of a capturing group from the first match in a string.
 * Defaults to the first group (index 1) if no groupIndex is provided.
 * Throws if groupIndex is 0 or less, since 0 is the full match.
 * @function
 * @param {string} str - String to search in.
 * @param {RegExp} regex - Regex pattern with capturing groups.
 * @param {number} [groupIndex=1] - Capturing group index (must be >= 1).
 * @returns {string|null} The captured value or null if no match found.
 * @throws {RangeError} If groupIndex is 0 or less.
 */
function extractCapturingGroup(str, regex, groupIndex = 1) {
    if (groupIndex < 1) {
        throw new RangeError(
            'groupIndex must be >= 1. Index 0 refers to the full match, not a group.'
        );
    }
    const match = regex.exec(str);
    return match?.[groupIndex] ?? null;
}

module.exports = {
    extractCapturingGroup: extractCapturingGroup
};
